import React, { FC, useRef, useEffect } from 'react'
import styled, { keyframes } from 'styled-components'
import fonts from 'components/base-ui/Fonts'
import { bounceIn } from 'react-animations'

interface BounceNotificationProps {
  quantity: number
  size?: string
}

const BounceNotification: FC<BounceNotificationProps> = ({ quantity, size = '20px' }) => {
  const refBtnCart = useRef<HTMLDivElement>(null)
  useEffect(() => shackNotification(), [quantity])

  return (
    <CircleNumber ref={refBtnCart} size={size}>
      {quantity}
    </CircleNumber>
  )

  function shackNotification() {
    if (refBtnCart && refBtnCart.current) {
      const currentTarget = refBtnCart.current
      currentTarget.classList.remove('-shake')
      setTimeout(() => currentTarget.classList.add('-shake'))
    }
  }
}

export default BounceNotification

const BounceAnimation = keyframes`${bounceIn}`

const CircleNumber = styled.div<{ size: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: ${({ size }) => size};
  height: ${({ size }) => size};
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.volcano600};
  box-shadow: 2px 2px 15px rgba(255, 255, 255, 0.5);
  font-size: 1em;
  font-weight: ${fonts.weight.bold};
  color: white;

  &.-shake {
    animation: ${BounceAnimation} 0.8s linear forwards;
  }
`
